import { Outlet } from "react-router-dom";

const Procedures = () => {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default Procedures;
